import { ApolloProvider } from "@apollo/client";
import { PrimeReactProvider } from "primereact/api";
import "primereact/resources/themes/saga-blue/theme.css";
import { createRoot } from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import apolloClient from "./apollo-client";
import { EnvProvider } from "./components/crown-data-import/env/env-context";
import { ROUTER_CONFIG } from "./router-config";

const router = createBrowserRouter(ROUTER_CONFIG);

const container = document.querySelector("#root");
if (container !== null) {
  const root = createRoot(container);
  // EnvProvider sits above the router so there is exactly one target env for the
  // whole tool. Mounted per page instead, each route seeded its own state from
  // localStorage and the trees could disagree, while Apollo re-reads localStorage
  // per request and followed the newest write: the UI could name one env while
  // the request went to another.
  root.render(
    <PrimeReactProvider>
      <ApolloProvider client={apolloClient}>
        <EnvProvider>
          <RouterProvider router={router} />
        </EnvProvider>
      </ApolloProvider>
    </PrimeReactProvider>,
  );
}
